/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import { baseUrl } from '@/model/storage/index'
import unit from '@/model/storage/Unit'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    form: false,
  },
  name: {
  },
  unitIds: {
    type: IKDataEntity.Types.Option,
    tableConfig: { overwrite: true },
    formConfig: {
      type: {
        multiple: true,
        selectItems: async () => {
          return await unit.getList(true)
        },
        itemText: 'name',
      },
    },
  },
  note: {},
}
const entityName = 'resourceUnitSet'
const config = {
  add: async function (item) {
    const res = await hillo.jsonPost(
      baseUrl + entityName + '/create',
      { name: item.name, note: item.note },
      {
      showLoading: false,
    })
    await editUnits(res.data.id, item.unitIds)
    return res.data
  },
  edit: function (item) {
    return hillo.jsonPost(baseUrl + entityName + '/edit/' + item.id, item, {
      showLoading: false,
    })
  },
  remove: function (id) {
    return hillo.post(baseUrl + entityName + '/delete/' + id,
      { id: id },
    )
  },
  load: async function () {
    return (await hillo.jsonPost(baseUrl + entityName + '/getList', {}))
      .data.map(it => {
        it.name = it.resourceUnitSet.name
        it.id = it.resourceUnitSet.id
        it.unitIds = it.resourceUnits.map(he => he.id).join(',')
        it.note = it.resourceUnitSet.note
        return it
      })
  },
}

export async function editUnits (id, units) {
  return await hillo.jsonPost(baseUrl + entityName + '/editUnits/' + id, { unitIds: units })
}

export default IKDataEntity.ModelFactory(entity, config)
